import { axiosInstance } from "./AxiosInstance"

const API_URL = "/receipts"
const RECEIPTS_PAGE_CAP = 100
const RECEIPTS_DEFAULT_LIMIT = 10

export const getReceipts = async (limit = 10, email, includeTotal = true) => {
  try {
    if (typeof limit === "object" && limit !== null) {
      const {
        limit: pageSize = RECEIPTS_DEFAULT_LIMIT,
        page = 1,
        email,
        studentEmail,
        studentIds,
        includeTotal = true,
        search = "",
        searchField = "receiptNo",
        fromDate,
        toDate,
        receiptType,
        sort,
        isDeleted,
      } = limit

      const safeLimit = Math.max(
        1,
        Math.min(RECEIPTS_PAGE_CAP, Number.parseInt(pageSize, 10) || RECEIPTS_DEFAULT_LIMIT)
      )
      const safePage = Math.max(1, Number.parseInt(page, 10) || 1)
      const qp = new URLSearchParams()
      qp.set("limit", String(safeLimit))
      qp.set("page", String(safePage))
      if (email) qp.set("email", String(email))
      if (studentEmail) qp.set("studentEmail", String(studentEmail))
      if (studentIds) qp.set("studentIds", Array.isArray(studentIds) ? studentIds.join(",") : String(studentIds))
      if (search) qp.set("search", String(search))
      if (searchField) qp.set("searchField", String(searchField))
      if (fromDate) qp.set("fromDate", String(fromDate))
      if (toDate) qp.set("toDate", String(toDate))
      if (receiptType) qp.set("receiptType", String(receiptType))
      if (sort) qp.set("sort", String(sort))
      if (typeof isDeleted !== "undefined") qp.set("isDeleted", String(isDeleted))
      qp.set("includeTotal", includeTotal ? "true" : "false")

      const response = await axiosInstance.get(`${API_URL}?${qp.toString()}`)
      return response.data
    }

    const safeLimit = Math.max(
      1,
      Math.min(RECEIPTS_PAGE_CAP, Number.parseInt(limit, 10) || RECEIPTS_DEFAULT_LIMIT)
    )
    const qp = new URLSearchParams()
    qp.set("limit", String(safeLimit))
    if (email) qp.set("email", String(email))
    qp.set("includeTotal", includeTotal ? "true" : "false")
    const response = await axiosInstance.get(`${API_URL}?${qp.toString()}`)
    return response.data
  } catch (error) {
    console.error("Error fetching receipts", error)
    throw error
  }
}

export const addReceipt = async (receiptData) => {
  try {
    const response = await axiosInstance.post(API_URL, {
      ...receiptData,
      isDeleted: false,
    })
    return response.data
  } catch (error) {
    console.error("Error adding receipt", error)
    throw error
  }
}

export const updateReceipt = async (receipt, receiptId) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${receiptId}`, receipt)
    return response.data
  } catch (error) {
    console.error("Error updating receipt", error)
    throw error
  }
}

export const deleteReceipt = async (receiptId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${receiptId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting receipt", error)
    throw error
  }
}

export const getReceiptById = async (receiptId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${receiptId}`)
    return response.data
  } catch (error) {
    console.error("Error fetching receipt by ID", error)
    throw error
  }
}

export const patchReceipt = async (receiptId, patchData) => {
  try {
    const response = await axiosInstance.patch(`${API_URL}/${receiptId}`, patchData)
    return response.data
  } catch (error) {
    console.error("Error patching receipt", error)
    throw error
  }
}
